'use es6';

import { List } from 'immutable';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import I18n from 'I18n';
import styled, { css } from 'styled-components';
import { AVATAR_SIZES } from 'visitor-ui-component-library/avatar/constants/AvatarSizes';
import ChatHeadingConfigPropType from 'conversations-prop-types/prop-types/ChatHeadingConfigPropType';
import ChatHeadingAvatars from './ChatHeadingAvatars';
import { getWidgetTitleText } from '../operators/getWidgetTitleText';
import { SMALL } from 'visitor-ui-component-library/constants/sizes';
import { HEADER_TEXT_TITLE_ID, HEADER_TEXT_DESCRIPTION_ID } from '../../visitor-widget/constants/textIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BORDER_WIDTH = 2;
const Wrapper = styled.div.withConfig({
  displayName: "WidgetHeaderAvatarWrapper__Wrapper",
  componentId: "sc-12k5cn7-0"
})(["display:inline-flex;align-items:center;flex:1 1 auto;height:", "px;min-width:0;"], AVATAR_SIZES[SMALL] + BORDER_WIDTH * 2);
const HeaderTextWrapper = styled.div.withConfig({
  displayName: "WidgetHeaderAvatarWrapper__HeaderTextWrapper",
  componentId: "sc-12k5cn7-1"
})(["display:flex;flex-direction:column;height:100%;width:100%;justify-content:center;min-width:0;"]);
const HeaderName = styled.h5.withConfig({
  displayName: "WidgetHeaderAvatarWrapper__HeaderName",
  componentId: "sc-12k5cn7-2"
})(["line-height:20px;margin-bottom:0;font-size:", ";"], props => props.titleText && props.titleText.length > 20 ? '14px' : null);
const MutedMessage = styled.div.withConfig({
  displayName: "WidgetHeaderAvatarWrapper__MutedMessage",
  componentId: "sc-12k5cn7-3"
})(["font-size:11px;line-height:initial;"]);
const TruncateString = styled.div.withConfig({
  displayName: "WidgetHeaderAvatarWrapper__TruncateString",
  componentId: "sc-12k5cn7-4"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;", ";"], ({
  theme
}) => {
  var _theme$config;
  return ((_theme$config = theme.config) === null || _theme$config === void 0 ? void 0 : _theme$config.isUngatedForUpdatedUI) && css(["font-weight:700;"]);
});
class WidgetHeaderAvatarWrapper extends PureComponent {
  render() {
    const {
      availabilityMessage,
      chatHeadingConfig,
      chatHeadingResponders,
      locale,
      mobile,
      showAvailabilityMessage,
      showStatusIndicator,
      borderColor
    } = this.props;
    const titleText = getWidgetTitleText(chatHeadingConfig, chatHeadingResponders, locale) || I18n.text('conversations-visitor-experience-components.default.agent');
    const isResponderAI = chatHeadingResponders.some(responder => responder.get('isResponderAI'));
    return /*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsx("div", {
        "data-test-id": "chat-heading-avatar",
        children: /*#__PURE__*/_jsx(ChatHeadingAvatars, {
          chatHeadingConfig: chatHeadingConfig,
          chatHeadingResponders: chatHeadingResponders,
          mobile: mobile,
          showStatusIndicator: showStatusIndicator,
          borderColor: borderColor
        })
      }), /*#__PURE__*/_jsxs(HeaderTextWrapper, {
        className: "p-x-3",
        children: [/*#__PURE__*/_jsx(HeaderName, {
          titleText: titleText,
          "aria-level": "1",
          children: /*#__PURE__*/_jsx(TruncateString, {
            children: /*#__PURE__*/_jsx("span", {
              "data-test-id": "widget-header-name",
              className: "widget-header-name p-y-0",
              id: HEADER_TEXT_TITLE_ID,
              children: titleText
            })
          })
        }), showAvailabilityMessage && !isResponderAI && /*#__PURE__*/_jsx(MutedMessage, {
          "data-test-type": "timestamp",
          id: HEADER_TEXT_DESCRIPTION_ID,
          children: availabilityMessage
        }), isResponderAI && /*#__PURE__*/_jsx(MutedMessage, {
          "data-test-id": "is-responder-ai-msg",
          children: I18n.text('conversations-visitor-experience-components.isResponderAI')
        })]
      })]
    });
  }
}
WidgetHeaderAvatarWrapper.displayName = 'WidgetHeaderAvatarWrapper';
WidgetHeaderAvatarWrapper.defaultProps = {
  mobile: false,
  showStatusIndicator: false
};
WidgetHeaderAvatarWrapper.propTypes = {
  availabilityMessage: PropTypes.string,
  borderColor: PropTypes.string.isRequired,
  chatHeadingConfig: ChatHeadingConfigPropType.isRequired,
  chatHeadingResponders: PropTypes.instanceOf(List).isRequired,
  locale: PropTypes.string,
  mobile: PropTypes.bool.isRequired,
  showAvailabilityMessage: PropTypes.bool.isRequired,
  showStatusIndicator: PropTypes.bool.isRequired
};
export default WidgetHeaderAvatarWrapper;